import React, { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import StepsPanel from '@app/components/StepsPanel/StepsPanel';
import { CompositeView, FormContext, FormSubmitButton, GridView, MasterDetailForm, SimpleView, useRouter } from '@digital/ui';
import { Tooltip, Icon } from 'antd';
import { useRecoilState } from 'recoil';
import StepDefinicaoTipoSolicitacao from './Steps/StepDefinicaoTipoSolicitacao';
import StepPreenchimentoSolicitacao from './Steps/StepPreenchimentoDaSolicitacao';
import { solicitacaoIdState, solicitacaoState, activeStepHashState, reloadState, orcadoAnoParametroState, aprovacoesSolicitacaoState, usuarioPermissaoState } from '../atoms';
import { IGroupItemStep, IItemStep } from '@app/components/StepsPanel/interfaces';
import { avancarSolicitacaoNaoPrevisto, getAprovacoesNaoPrevisto, getSolicitacaoNaoPrevisto, getUsuarioPermissaoSolicitacao } from '@app/api/naoPrevistos/solicitacao';
import AbaHistorico from './AbaHistorico';
import { EStatusAprovacaoSolicitacaoNaoPrevisto, EStatusSolicitacaoNaoPrevisto, EStepsSolicitacaoNaoPrevisto, ETipoAprovacaoSolicitacaoNaoPrevisto, ETipoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import '../custom.css';
import { getOrcadoAnoNaoPrevistoByAno } from '@app/api/naoPrevistos/parametros';
import ModalAprovarSolicitacao from '../Validacao/ModalAprovarSolicitacao';
import ModalReprovarSolicitacao from '../Validacao/ModalReprovarSolicitacao';
import StepFinalizado from './Steps/StepFinalizado';
import AbaAcompanhamentoAdmin from './AcompanhamentoAdmin/AbaAcompanhamentoAdmin';
import { hasPermission } from '@app/helpers/permissions';
import { convertUTCtoLocal, dateFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import StepVincularAoProjeto from './Steps/StepVincularAoProjeto';

const NaoPrevistosCadastroIndex = () => {
    const { match } = useRouter();
    const [id, setId] = useRecoilState(solicitacaoIdState);
    const [solicitacao, setSolicitacao] = useRecoilState(solicitacaoState);
    const [usuarioPermissaoSolicitacao, setUsuarioPermissaoSolicitacao] = useRecoilState(usuarioPermissaoState);
    const [aprovacoesSolicitacao, setAprovacoesSolicitacao] = useRecoilState(aprovacoesSolicitacaoState);
    const [orcadoAnoParametro, setOrcadoAnoParametro] = useRecoilState(orcadoAnoParametroState);
    const [activeStepHash, setActiveStepHash] = useRecoilState<string>(activeStepHashState);
    const [reload, setReload] = useRecoilState(reloadState);
    const [activeStep, setActiveStep] = useState(0);
    const [validationScheme, setValidationScheme] = useState(Yup.object().shape({}));
    const [legend, setLegend] = useState('Formulário');
    const [hasNaoValidado, setHasNaoValidado] = useState(false);

    useEffect(() => {
        setHasNaoValidado(aprovacoesSolicitacao.some(objeto => objeto.statusAprovacaoSolicitacaoNaoPrevistoNome === "Não Validado"));
    }, [aprovacoesSolicitacao])

    const groupsSteps: IGroupItemStep[] = useMemo((): IGroupItemStep[] => {
        let groups = [] as IGroupItemStep[];
        const iconReproved = solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao || solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao
            ? undefined : <Icon type="close-circle" style={{ color: 'red' }} />
        let icon = undefined
        // const reprovada = solicitacao.statusId && (solicitacao.statusId.includes(EStatusSolicitacaoNaoPrevisto.Reprovado) || solicitacao.statusId.includes(EStatusSolicitacaoNaoPrevisto.NaoValidado))
        let formulario = {
            title: 'Preenchimento',
            order: 1,
            steps: [] as IItemStep[],
        } as IGroupItemStep;

        formulario.steps.push({
            stepNumber: 0,
            order: 0,
            title: 'Definição do Tipo da Solicitação',
            description: solicitacao.dataConclusaoDefinicaoDoTipoSolicitacao ? <><span>{solicitacao.nomeSolicitante}<br></br>{moment(convertUTCtoLocal(moment(solicitacao.dataConclusaoDefinicaoDoTipoSolicitacao))).format(dateFormat)}</span></> : <></>,
            content: <StepDefinicaoTipoSolicitacao />,
            visible: true,
            hash: EStepsSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao,
            icon: icon
        });

        formulario.steps.push({
            stepNumber: 1,
            order: 1,
            title: 'Preenchimento da Solicitação',
            description: solicitacao.dataConclusaoPreenchimentoDaSolicitacao ? <><span>{solicitacao.nomeSolicitante}<br></br>{moment(convertUTCtoLocal(moment(solicitacao.dataConclusaoPreenchimentoDaSolicitacao))).format(dateFormat)}</span></> : <></>,
            content: <StepPreenchimentoSolicitacao />,
            visible: true,
            hash: EStepsSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao,
            icon: icon
        });
        groups.push(formulario);

        if (aprovacoesSolicitacao && aprovacoesSolicitacao.length > 0) {
            const validacaoGerenciaGFG = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoGerenciaGFG);
            const validacaoAdministrador = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoAdministrador);
            const validacaoGDGPP = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoGDGPP);

            let validacoes = {
                title: 'Validações',
                order: 2,
                steps: [] as IItemStep[],
            } as IGroupItemStep;


            if (validacaoAdministrador) {
                if (validacaoAdministrador.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.NaoValidado) icon = iconReproved
                validacoes.steps.push({
                    stepNumber: 2,
                    order: 2,
                    title: 'Validação Administrador',
                    description: validacaoAdministrador.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{validacaoAdministrador.aprovador}<br></br>{validacaoAdministrador.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.ValidacaoAdministrador,
                    disabled: hasNaoValidado && validacaoAdministrador.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }


            if (validacaoGerenciaGFG) {
                if (validacaoGerenciaGFG.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.NaoValidado) icon = iconReproved
                validacoes.steps.push({
                    stepNumber: 3,
                    order: 3,
                    title: 'Validação Gerência GFG',
                    description: validacaoGerenciaGFG.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{validacaoGerenciaGFG.aprovador}<br></br>{validacaoGerenciaGFG.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.ValidacaoGerenciaGFG,
                    disabled: hasNaoValidado && validacaoGerenciaGFG.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }

            if (validacaoGDGPP) {
                if (validacaoGDGPP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.NaoValidado) icon = iconReproved
                validacoes.steps.push({
                    stepNumber: 4,
                    order: 4,
                    title: 'Validação (GD GPP)',
                    description: validacaoGDGPP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{validacaoGDGPP.aprovador}<br></br>{validacaoGDGPP.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.ValidacaoGDGPP,
                    disabled: hasNaoValidado && validacaoGDGPP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }

            groups.push(validacoes);
        }

        if (aprovacoesSolicitacao && aprovacoesSolicitacao.length > 0) {
            const aprovacaoGerenteGeralAreaSolicitante = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.GerenteGeralAreaSolicitante);
            const aprovacaoDiretorAreaSolicitante = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorAreaSolicitante);
            const aprovacaoGerenteGeralGP = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.GerenteGeralGP);
            const aprovacaoDiretorImplantacao = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorImplantacao);
            const aprovacaoDiretorSustentabilidade = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorSustentabilidade);
            const aprovacaoDiretorOperacoes = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorOperacoes);
            const aprovacaoDiretorFinanceiro = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorFinanceiro);
            const aprovacaoDiretorPresidente = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorPresidente);
            const aprovacaoDiretorEstatutaria = aprovacoesSolicitacao.find(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria);
            console.log({ aprovacoesSolicitacao })

            let aprovacoes = {
                title: 'Aprovações',
                order: 3,
                steps: [] as IItemStep[],
            } as IGroupItemStep;

            if (aprovacaoGerenteGeralAreaSolicitante) {
                if (aprovacaoGerenteGeralAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
                aprovacoes.steps.push({
                    stepNumber: 5,
                    order: 5,
                    title: 'Gerente Geral Área Solicitante',
                    description: aprovacaoGerenteGeralAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{aprovacaoGerenteGeralAreaSolicitante.aprovador}<br></br>{aprovacaoGerenteGeralAreaSolicitante.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.GerenteGeralAreaSolicitante,
                    disabled: hasNaoValidado && aprovacaoGerenteGeralAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }

            if (aprovacaoDiretorAreaSolicitante) {
                if (aprovacaoDiretorAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
                aprovacoes.steps.push({
                    stepNumber: 6,
                    order: 6,
                    title: 'Diretor Área Solicitante',
                    description: aprovacaoDiretorAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{aprovacaoDiretorAreaSolicitante.aprovador}<br></br>{aprovacaoDiretorAreaSolicitante.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.DiretorAreaSolicitante,
                    disabled: hasNaoValidado && aprovacaoDiretorAreaSolicitante.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }

            if (aprovacaoGerenteGeralGP) {
                if (aprovacaoGerenteGeralGP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
                aprovacoes.steps.push({
                    stepNumber: 7,
                    order: 7,
                    title: 'Gerente Geral (GP)',
                    description: aprovacaoGerenteGeralGP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                        <><span>{aprovacaoGerenteGeralGP.aprovador}<br></br>{aprovacaoGerenteGeralGP.dataAprovacaoFormatada}</span></>,
                    content: <StepPreenchimentoSolicitacao />,
                    visible: true,
                    hash: EStepsSolicitacaoNaoPrevisto.GerenteGeralGP,
                    disabled: hasNaoValidado && aprovacaoGerenteGeralGP.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                    icon: icon
                });
            }

             if (aprovacaoDiretorImplantacao) {
                 if (aprovacaoDiretorImplantacao.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
                 aprovacoes.steps.push({
                     stepNumber: 8,
                     order: 7,
                     title: 'Diretor de Implantação (DI)',
                     description: aprovacaoDiretorImplantacao.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                         <><span>{aprovacaoDiretorImplantacao.aprovador}<br></br>{aprovacaoDiretorImplantacao.dataAprovacaoFormatada}</span></>,
                     content: <StepPreenchimentoSolicitacao />,
                     visible: true,
                     hash: EStepsSolicitacaoNaoPrevisto.DiretorImplantacao,
                     disabled: hasNaoValidado && aprovacaoDiretorImplantacao.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                     icon: icon
                 });
             }

            // if (aprovacaoDiretorSustentabilidade) {
            //     if (aprovacaoDiretorSustentabilidade.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
            //     aprovacoes.steps.push({
            //         stepNumber: 9,
            //         order: 9,
            //         title: 'Diretor de Sustentabilidade (DS)',
            //         description: aprovacaoDiretorSustentabilidade.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
            //             <><span>{aprovacaoDiretorSustentabilidade.aprovador}<br></br>{aprovacaoDiretorSustentabilidade.dataAprovacaoFormatada}</span></>,
            //         content: <StepPreenchimentoSolicitacao />,
            //         visible: true,
            //         hash: EStepsSolicitacaoNaoPrevisto.DiretorSustentabilidade,
            //         disabled: hasNaoValidado && aprovacaoDiretorSustentabilidade.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
            //         icon: icon
            //     });
            // }

            // if (aprovacaoDiretorOperacoes) {
            //     if (aprovacaoDiretorOperacoes.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
            //     aprovacoes.steps.push({
            //         stepNumber: 9,
            //         order: 9,
            //         title: 'Diretor de Operações (DO)',
            //         description: aprovacaoDiretorOperacoes.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
            //             <><span>{aprovacaoDiretorOperacoes.aprovador}<br></br>{aprovacaoDiretorOperacoes.dataAprovacaoFormatada}</span></>,
            //         content: <StepPreenchimentoSolicitacao />,
            //         visible: true,
            //         hash: EStepsSolicitacaoNaoPrevisto.DiretorOperacoes,
            //         disabled: hasNaoValidado && aprovacaoDiretorOperacoes.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
            //         icon: icon
            //     });
            // }

            // if (aprovacaoDiretorFinanceiro) {
            //     if (aprovacaoDiretorFinanceiro.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
            //     aprovacoes.steps.push({
            //         stepNumber: 10,
            //         order: 11,
            //         title: 'Diretor Financeiro (DF)',
            //         description: aprovacaoDiretorFinanceiro.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
            //             <><span>{aprovacaoDiretorFinanceiro.aprovador}<br></br>{aprovacaoDiretorFinanceiro.dataAprovacaoFormatada}</span></>,
            //         content: <StepPreenchimentoSolicitacao />,
            //         visible: true,
            //         hash: EStepsSolicitacaoNaoPrevisto.DiretorFinanceiro,
            //         disabled: hasNaoValidado && aprovacaoDiretorFinanceiro.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
            //         icon: icon
            //     });
            // }

            // if (aprovacaoDiretorPresidente) {
            //     if (aprovacaoDiretorPresidente.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
            //     aprovacoes.steps.push({
            //         stepNumber: 12,
            //         order: 12,
            //         title: 'Diretor Presidente (DP)',
            //         description: aprovacaoDiretorPresidente.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
            //             <><span>{aprovacaoDiretorPresidente.aprovador}<br></br>{aprovacaoDiretorPresidente.dataAprovacaoFormatada}</span></>,
            //         content: <StepPreenchimentoSolicitacao />,
            //         visible: true,
            //         hash: EStepsSolicitacaoNaoPrevisto.DiretorPresidente,
            //         disabled: hasNaoValidado && aprovacaoDiretorPresidente.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
            //         icon: icon
            //     });
            // }

            if (aprovacaoDiretorEstatutaria) {
                aprovacoesSolicitacao.filter(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria).map((a, index) => {
                    if (a.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado) icon = iconReproved
                    
                    aprovacoes.steps.push({
                        stepNumber: 9 + index,
                        order: 9 + index,
                        title: 'Diretor Estatutária (DE)',
                        description: a.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente ? <></> :
                            <><span>{a.aprovador}<br></br>{a.dataAprovacaoFormatada}</span></>,
                        content: <StepPreenchimentoSolicitacao />,
                        visible: true,
                        hash: EStepsSolicitacaoNaoPrevisto.DiretorEstatutaria,
                        disabled: hasNaoValidado && a.statusAprovacaoSolicitacaoNaoPrevistoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Pendente,
                        icon: icon
                    });
                })
            }


            groups.push(aprovacoes);

            let informacoes = {
                title: 'Informações',
                order: 4,
                steps: [] as IItemStep[],
            } as IGroupItemStep;

            informacoes.steps.push({
                stepNumber: 10 + aprovacoesSolicitacao.filter(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria).length,
                order: 11 + aprovacoesSolicitacao.filter(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria).length,
                title: 'Vincular Não Previsto ao Projeto',
                description: solicitacao.dataConclusaoVincularAoProjeto ? <><span>{solicitacao.responsavelVincularAoProjeto}<br></br>{moment(convertUTCtoLocal(moment(solicitacao.dataConclusaoVincularAoProjeto))).format(dateFormat)}</span></> : <></>,
                content: <StepVincularAoProjeto />,
                visible: true,
                hash: EStepsSolicitacaoNaoPrevisto.VincularNaoPrevistoAoProjeto,
                disabled: hasNaoValidado && !solicitacao.dataConclusaoVincularAoProjeto,
                icon: icon
            });

            informacoes.steps.push({
                stepNumber: 12 + aprovacoesSolicitacao.filter(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria).length,
                order: 12 + aprovacoesSolicitacao.filter(c => c.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria).length,
                title: solicitacao.stepHash == EStepsSolicitacaoNaoPrevisto.Finalizado ? solicitacao.status : 'Finalizado',
                description: <></>,
                content: <StepFinalizado />,
                visible: true,
                hash: EStepsSolicitacaoNaoPrevisto.Finalizado,
                icon: icon
            });

            groups.push(informacoes);
        } else {
            let informacoes = {
                title: 'Informações',
                order: 4,
                steps: [] as IItemStep[],
            } as IGroupItemStep;

            informacoes.steps.push({
                stepNumber: 9,
                order: 9,
                title: 'Vincular Não Previsto ao Projeto',
                description: solicitacao.dataConclusaoVincularAoProjeto ? <><span>{solicitacao.responsavelVincularAoProjeto}<br></br>{moment(convertUTCtoLocal(moment(solicitacao.dataConclusaoVincularAoProjeto))).format(dateFormat)}</span></> : <></>,
                content: <StepVincularAoProjeto />,
                visible: true,
                hash: EStepsSolicitacaoNaoPrevisto.VincularNaoPrevistoAoProjeto,
                disabled: hasNaoValidado && !solicitacao.dataConclusaoVincularAoProjeto,
                icon: icon
            });

            informacoes.steps.push({
                stepNumber: 10,
                order: 10,
                title: solicitacao.stepHash == EStepsSolicitacaoNaoPrevisto.Finalizado ? solicitacao.status : 'Finalizado',
                description: <></>,
                content: <StepFinalizado />,
                visible: true,
                hash: EStepsSolicitacaoNaoPrevisto.Finalizado,
                icon: icon
            });

            groups.push(informacoes);
        }

        return groups;
    }, [solicitacao, aprovacoesSolicitacao])

    const getSolicitacao = () => {
        if (id) {
            getSolicitacaoNaoPrevisto(id).then((result) => {
                if (result && result.id) {
                    setSolicitacao(result)
                    setActiveStepHash(result.stepHash || EStepsSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao)
                }
            })
        }
    }

    const getAprovacoes = () => {
        if (id) {
            getAprovacoesNaoPrevisto(id).then((result) => {
                if (result && result.length > 0) {
                    console.log(result)
                    console.log({ axD: result })
                    setAprovacoesSolicitacao(result.filter(c => c.enabled === true))
                }
            })
        }
    }

    const getUsuarioPermissao = () => {
        if (id) {
            getUsuarioPermissaoSolicitacao(id).then((result) => {
                if (result) {
                    setUsuarioPermissaoSolicitacao(result)
                }
            })
        }
    }

    useEffect(() => {
        if (solicitacao && solicitacao.id && orcadoAnoParametro.ano !== solicitacao.ano) {
            getOrcadoAnoNaoPrevistoByAno(solicitacao.ano).then((result) => {
                if (result && result.id) {
                    setOrcadoAnoParametro(result);
                }
            })
        }
    }, [solicitacao])

    const onAvancarSolicitacao = (values: any) => {
        // Garante que não envia request se o schema Yup estiver acusando erro
        validationScheme
            .validate(values, { abortEarly: false })
            .then(() => {
                avancarSolicitacaoNaoPrevisto(values).then((result) => {
                    if (result && result.valid) {
                        window.location.href = `/naoPrevisto/solicitacao/${result.id}`;
                    }
                })
            })
            .catch(() => {
                // Erros já são exibidos pelos componentes (notification + campos em vermelho)
            });
    }

    useEffect(() => {
        if (activeStep === 0) {
            setValidationScheme(Yup.object().shape({
                tipo: Yup.string().required('O campo Tipo é obrigatório'),
                ano: Yup.string().required('O campo Ano é obrigatório'),
            }))
        }
        else if (activeStep === 1) {
            setValidationScheme(Yup.object().shape({
                adUserResponsavel: Yup.string().nullable().required('O campo é obrigatório'),
                nomeProjeto: Yup.string().nullable().required('O campo é obrigatório'),
                escopo: Yup.string().nullable().required('O campo é obrigatório'),
                vidaUtilEmMeses: Yup.string().nullable().required('O campo é obrigatório'),
                porQueAgora: Yup.string().nullable().required('O campo é obrigatório'),
                tipoNaoPrevistoId: Yup.string().nullable().required('O campo é obrigatório'),
                observacao: Yup.string().nullable().required('O campo é obrigatório'),
                forecastDoMes: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Forecast do Mês é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
                naoPrevistosAprovados: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Não Previstos Aprovados é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
                impactoNoForecast: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Impacto no Forecast Econômico é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
                forecastAtualizado: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Forecast Atualizado Econômico é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
                impactoNoForecastFinanceiro: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Impacto no Forecast Financeiro é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
                forecastAtualizadoFinanceiro: Yup.number().nullable().transform((v, o) => (o === '' || o === null || o === undefined ? 0 : v)).required('Forecast Atualizado Financeiro é obrigatório').min(0, 'Informe um valor válido').typeError('Informe um valor válido'),
            }))
        } else if (activeStep === 13) {
            setValidationScheme(Yup.object().shape({
                projetoId: Yup.string().nullable().when("tipo", (tipo: string, schema: any) =>
                    tipo.toLowerCase() == ETipoNaoPrevisto.CNP.toLowerCase() ? schema.required('O campo é obrigatório') : schema,
                ),
                crfProjetoId: Yup.string().nullable().when("tipo", (tipo: string, schema: any) =>
                    tipo.toLowerCase() == ETipoNaoPrevisto.ONP.toLowerCase() ? schema.required('O campo é obrigatório') : schema,
                ),
            }))
        }
    }, [activeStep])

    useEffect(() => {
        getSolicitacao()
        getAprovacoes()
        getUsuarioPermissao()
    }, [id, reload])

    useEffect(() => {
        if (activeStepHash) {
            groupsSteps.forEach((group) => {
                group.steps.forEach((step) => {
                    if (step.hash === activeStepHash) {
                        setActiveStep(step.stepNumber);
                    }
                })
            })
        }
    }, [activeStepHash, groupsSteps])

    useEffect(() => {
        setId(match.params.id);
    }, [match])

    useEffect(() => {
        if (solicitacao && solicitacao.tipo) {
            if (solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.CNP.toLowerCase()) {
                setLegend('Formulário - CapEx Não Previsto (CNP) - Investimento')
            }

            if (solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.ONP.toLowerCase()) {
                setLegend('Formulário - Orçamento Não Previsto (ONP) - Conta Resultado/ Fechamento de Mina')
            }
        }
    }, [solicitacao])

    const actions = () => {
        const acts: React.ReactNode[] = [];

        if (
            activeStepHash == EStepsSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao ||
            activeStepHash == EStepsSolicitacaoNaoPrevisto.VincularNaoPrevistoAoProjeto
        ) {
            acts.push(
                <Tooltip title="Avançar">
                    <FormSubmitButton
                        id='mrn-button-stepv2-next'
                        noIcon
                        title='Avançar'
                        type='success'
                        disabled={usuarioPermissaoSolicitacao.podeAvancar === false}
                    />
                </Tooltip>
            )
        } else if (activeStepHash == EStepsSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao) {
            acts.push(
                <Tooltip title="Enviar para Aprovação">
                    <FormSubmitButton
                        id='mrn-button-stepv2-next'
                        noIcon
                        title='Enviar para Aprovação'
                        type='success'
                        disabled={usuarioPermissaoSolicitacao.podeAvancar === false}
                    />
                </Tooltip>
            )
        }
        else if (activeStepHash != EStepsSolicitacaoNaoPrevisto.Finalizado) {
            acts.push(
                <ModalReprovarSolicitacao disabled={usuarioPermissaoSolicitacao.podeAprovar === false} />
            )

            acts.push(
                <ModalAprovarSolicitacao disabled={usuarioPermissaoSolicitacao.podeAprovar === false} />
            )
        }

        return acts;
    }

    return (
        <SimpleView>
            <CompositeView>
                <GridView icon="ui-in_progress" title="Solicitação" id="solicitacao" noform>
                    <MasterDetailForm initialValues={solicitacao || {}} onSubmit={onAvancarSolicitacao} validationSchema={validationScheme} >
                        <FormContext.Consumer>
                            {({ formProps }) => <>
                                {activeStep !== undefined &&
                                    <StepsPanel
                                        groupSteps={groupsSteps}
                                        contentLegend={legend}
                                        actions={actions()}
                                        numberCurrentStep={activeStep}
                                    />
                                }
                            </>}
                        </FormContext.Consumer>
                    </MasterDetailForm>
                </GridView>
                <GridView icon="ui-in_progress" title="Histórico" id="historico" noform>
                    <AbaHistorico />
                </GridView>
                {
                    hasPermission(['NAO_PREVISTO_ADMINISTRADOR']) ? (
                        <GridView icon="ui-in_progress" title="Acompanhamento" id="acompanhamentoAdmin" noform>
                            <AbaAcompanhamentoAdmin />
                        </GridView>
                    ) : (
                        () => { }
                    )
                }
            </CompositeView>
        </SimpleView>
    );
};

export default NaoPrevistosCadastroIndex;
